<ion-text
  [innerHTML]="translationId | translate : getPlaceholders()"
  class="greeting__receiver-name"
  *ngIf="userName"
>
</ion-text>
